import * as React from "react";
import { useCallback } from "react";
import { useErrorBoundary } from "react-error-boundary";
import { Route } from "react-router";
import { Routes, useNavigate } from "react-router-dom";
import { useUpdatePatientStatus } from "api";
import { isNil } from "ramda";
import { styled } from "styled-components";

import { Button, ButtonVariants, NavigateButton } from "affinityUI/elements/button";
import { Card, Container } from "affinityUI/elements/card";
import { StatusView } from "affinityUI/features/statusView";
import { ButtonGroup } from "affinityUI/form/components";
import { Layout } from "affinityUI/structures/layout";
import { IssueDeviceView } from "components/views/patientDetails/device/issueDevice";

import { usePatient } from "../context";

import deviceIssued from "./assets/issued.svg";
import { PatientInfo } from "./components/patientInfo";

const StatusContainer = styled(Container)`
  border-top: 1px solid ${(props) => props.theme.colours.bordersLight};
`;

export const IssueDevice: React.FC = () => {
  const { showBoundary: onError } = useErrorBoundary();
  const navigate = useNavigate();

  const { patient, loading, refetch } = usePatient();

  const patientId = patient?.id;
  const { updatePatientStatus, loading: loadingEnrollment } = useUpdatePatientStatus();

  const handleIssueClick = useCallback(async () => {
    if (!isNil(patientId)) {
      try {
        await updatePatientStatus(patientId);
        await refetch();
        navigate(`/patients/${patientId}`);
      } catch (e) {
        onError(e);
      }
    }
  }, [navigate, onError, patientId, updatePatientStatus, refetch]);

  const actions = (
    <ButtonGroup>
      <NavigateButton to={`/patients/${patientId}`} variant={ButtonVariants.SECONDARY}>
        Cancel
      </NavigateButton>
      <Button disabled={loadingEnrollment} onClick={handleIssueClick} variant={ButtonVariants.PRIMARY}>
        {loadingEnrollment ? "Sending request" : "Issue Device"}
      </Button>
    </ButtonGroup>
  );
  return (
    <Layout
      title={!isNil(patient) ? `Issue device to ${patient?.firstName} ${patient?.lastName}` : "Issue device"}
      showBackBtn
      backLink=".."
      loading={loading}
    >
      <Card>
        {!isNil(patient) ? <PatientInfo patient={patient} /> : null}
        <Routes>
          <Route
            index
            element={
              <IssueDeviceView actions={<NavigateButton to="confirm">Continue to Confirmation</NavigateButton>} />
            }
          />
          <Route
            path="/confirm"
            element={
              <StatusContainer>
                <StatusView imgSrc={deviceIssued} heading="Please confirm" actions={actions}>
                  Are you sure you want to send a device to the above address?
                </StatusView>
              </StatusContainer>
            }
          />
        </Routes>
      </Card>
    </Layout>
  );
};
